import { useUpdateModelMutation } from "@/hooks";
import { Model } from "@/types";
import { ModelEditor } from "./model-editor";

export function FormModelUpdate({ handleClose, model }: { handleClose: () => void; model: Model }) {
  const mutation = useUpdateModelMutation();
  return <ModelEditor model={model} handleClose={handleClose} save={values => mutation.mutateAsync({ ...values, id: model.id })} isLoading={mutation.isLoading} />;
}
